export const avatarDB = {
  chaupalAvatar:
    "https://res.cloudinary.com/drkcsvbdj/image/upload/v1728022225/samples/animals/cat.jpg",
  dedsecAvatar:
    "https://res.cloudinary.com/drkcsvbdj/image/upload/v1728022233/samples/look-up.jpg",
  jeetsdevAvatar:
    "https://res.cloudinary.com/drkcsvbdj/image/upload/v1728022233/samples/man-portrait.jpg",
  adiiAvatar:
    "https://res.cloudinary.com/drkcsvbdj/image/upload/v1728022234/samples/woman-on-a-football-field.jpg",
  harviAvatar:
    "https://res.cloudinary.com/drkcsvbdj/image/upload/v1728022235/cld-sample.jpg",
  ninjaAvatar:
    "https://res.cloudinary.com/drkcsvbdj/image/upload/v1728022234/samples/dessert-on-a-plate.jpg",
  capAvatar:
    "https://res.cloudinary.com/drkcsvbdj/image/upload/v1728022233/samples/outdoor-woman.jpg",
  tonyAvatar:
    "https://res.cloudinary.com/drkcsvbdj/image/upload/v1728022233/samples/man-on-a-street.jpg",
};
